// extracted by mini-css-extract-plugin
export default {"responsiveIframe":"CreateSchufaView_responsiveIframe__9+Rsr"};